module.exports = __webpack_public_path__ + "img/BIT_white04.1420de4f.jpg";